module.exports = __webpack_public_path__ + "img/upload.992f4190.jpg";